import { Context, createContext, useContext } from 'react';

export type ErrorContainer = Record<string, string>;

export type SetError = (inputFieldName: string, message: string) => void;

export type ClearErrors = () => void;

export type FormErrorContextState = [ErrorContainer, SetError, ClearErrors];

export const FormErrorContext: Context<FormErrorContextState> =
    createContext<FormErrorContextState>(null);

export const useFormErrorContext = () => useContext(FormErrorContext);
